<template>
  <component :is="currentPrivacyComponent" />
</template>

<script>
import PrivacyGold from './privacy/privacyGold.vue'
import PrivacyTiger from './privacy/privacyTiger.vue'
import themeMixin from '@/mixins/themeMixin'

export default {
  components: {
    PrivacyGold,
    PrivacyTiger
  },
  mixins: [themeMixin],
  computed: {
    currentPrivacyComponent() {
      switch (this.currentTheme) {
        case 'theme_tiger':
          return 'PrivacyTiger'
        case 'theme_gold':
        default:
          return 'PrivacyGold'
      }
    }
  }
}
</script>
